<template>
  <div id="esUser">
    <header>
      <div class="ef--inner first">
        <h1>
          <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報" />
        </h1>
      </div>
      <nav>
        <div class="ef--inner">
          <div class="nav-area">
            <ul>
              <li class="li-bottom">
                <a @click="$router.push('/es/multi_circuit_graph_list')">
                  <img src="/assets/images/common/menu.icon7.png">
                  <span>グラフ</span>
                </a>
              </li>
              <li class="li-bottom">
                <a href="javascript:void(0);" @click="downloadDialog = true">
                  <img src="/assets/images/common/admin_menu.icon3.png">
                  <span>CSV出力</span>
                </a>
              </li>
              <li class="li-bottom" v-if="this.$store.state.loginID == 'ninnbeppu'">
                <a href="javascript:void(0);" @click="$router.push('/es/nInnBeppuController')">
                  <img src="/assets/images/common/admin_menu.icon5.png">
                  <span>制御</span>
                </a>
              </li>
            </ul>
            <div class="user">
              <span>{{ username }}さま</span>
              <a v-if="this.$store.state.loginType != 3" @click="$router.push('/es/es_setting')">お客さま設定</a>
              <a @click="onLogout()">ログアウト</a>
            </div>
          </div>
          <div class="panel">
            <div class="menu-trigger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <router-view />
    <footer>
      <div class="ef--inner">
        <p>
          Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.
        </p>
      </div>
    </footer>

    <download-dialog
      @close="downloadDialog=false"
      v-if="downloadDialog"
      :account="this.$store.state.loginID"
    ></download-dialog>

  </div>
</template>

<script>
import DownloadDialog from "../TakairoCsvDownloadDialog";

export default {
  name: "esUser",
  components: {
    DownloadDialog
  },
  data: function() {
    return {
      downloadDialog: false
    }
  },
  computed: {
    username() {
      const obj = this.$store.state.childInfo;
      return obj != null ? obj.base_info.company_name : this.$store.state.childID;
    },
  },

  mounted: function () {
    /* eslint-disable no-undef */
    /* sp panel */
    $(".panel").on("click", function () {
      // console.log('admin:panel_click');

      $(".menu-trigger, header nav").toggleClass("active");
      $("nav .nav-area").slideToggle();
      $(".overlay").fadeToggle("slow");
    });
    $(".overlay").on("click", function () {
      $(".overlay, nav .nav-area").fadeToggle("slow");
      $(".menu-trigger, header nav").removeClass("active");
    });
  },

  methods: {
    onLogout: function () {
      const self = this;
      const params = new URLSearchParams();
      this.$store.dispatch("logout");
      this.$store.commit("RESET");
      this.$axios
        .post(`/srv/api/logout`, params, {
          withCredentials: true
        })
        .then(response => {
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              self.$router.push("/login");
            } else {
              // eslint-disable-next-line no-console
              console.error(response);
              self.$router.push("/login");
            }
          } else {
            // eslint-disable-next-line no-console
            console.error(response);
            self.$router.push("/login");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  }
};
</script>
